export const compare=(a, b)=> {
  if(a.Description === null || b.Description === null || b.Label === null || a.Label === null  || a.Name === null || b.Name === null
    || a.WeekNo === null || b.WeekNo === null || a.DOD === null || b.DOD === null){


    return;

  }
  else{

    const genreA = a&&a?.Name ? a?.Name.toUpperCase() : a?.Label ? a?.Label.toUpperCase(): a?.Description ? a?.Description.toUpperCase(): a?.DOD ? a?.DOD : a?.WeekNo;
    const genreB = b&& b?.Name ?b?.Name.toUpperCase(): b?.Label?  b?.Label.toUpperCase() : b?.Description ? b?.Description.toUpperCase(): b?.DOD ? b?.DOD : b?.WeekNo;
    
    let comparison = 0;
    if (genreA > genreB) {
      comparison = 1;
    } else if (genreA < genreB) {
      comparison = -1;
    }
    return comparison;
  }
  }
